import React from 'react';
import { Offcanvas, OffcanvasBody, OffcanvasHeader } from 'reactstrap';

import JobPost from '../../templates/jobs/dynamic-job-post';
import LoadingSpinner from '../common/LoadingSpinner';

const OffcanvasJobView = (props: {
  jobId?: string | undefined;
  toggle: (jobId) => void;
}) => {
  return (
    <Offcanvas
      isOpen={!!props.jobId}
      direction="end"
      style={{ width: '900px', maxWidth: '100%' }}
      toggle={() => props.toggle(undefined)}
    >
      <OffcanvasHeader toggle={() => props.toggle(undefined)} />
      <OffcanvasBody>
        {props.jobId ? <JobPost jobId={props.jobId} /> : <LoadingSpinner />}
      </OffcanvasBody>
    </Offcanvas>
  );
};

export default OffcanvasJobView;
